function convertAssessmentQuestionViewToSave(question, assessmentScoringEnabled) {
    const scoringEnabled = assessmentScoringEnabled && question.attributes.scoring_enabled;
    return {
        ...question,
        attributes: {
            ...question.attributes,
            group_id: question.group?.id,
            blockedDays: question.blockedDays?.reduce((agg, currDay) => ({ ...agg, [currDay.value]: true }), {}),
            risk_config: scoringEnabled ? question.attributes.risk_config?.id : null,
            risk_weight: scoringEnabled ? question.attributes.risk_weight : null,
            numericRiskType: scoringEnabled ? question.attributes.numericRiskType?.value : null,
        },
    };
}

export default convertAssessmentQuestionViewToSave;
